import React, { forwardRef } from 'react';
import { useMatches } from 'react-router-dom';

function withMatch(Component) {
  const WrappedComponent = forwardRef((props, ref) => {
    const matches = useMatches();
    const lastMatch = matches[matches.length - 1] ?? { url: '', params: {} };
    const match = {
      url: lastMatch.pathname,
      params: lastMatch.params ?? {},
    };

    return (
      <Component
        {...props}
        match={match}
        ref={ref}
      />
    );
  });

  WrappedComponent.displayName = `withMatch(${Component.displayName || Component.name})`;
  return WrappedComponent;
}

export default withMatch;
